import type { FaireProductEntity } from "../../entity_types/product";

export const toysmith_8: FaireProductEntity = {
  token: "toysmith-8",
  type: "product",
  name: "On the Way Games Magnetic Travel Games, 6 Games, 24/Display",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/3c1e5d244eb1a1ef824d5754aff902f12a9ed478ed6210fab5784408bbf8b2eb.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1286,1286,x257,y557,safe&width=720",
  priceDollars: 11,
  msrpDollars: 22,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
